import { render, staticRenderFns } from "./HowToUsePopup.vue?vue&type=template&id=747dc5c6"
import script from "./HowToUsePopup.vue?vue&type=script&lang=ts"
export * from "./HowToUsePopup.vue?vue&type=script&lang=ts"
import style0 from "./HowToUsePopup.vue?vue&type=style&index=0&id=747dc5c6&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports